import { useState, useEffect } from 'react';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setMenuOpen(false);
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md' : 'bg-black/80'}`}>
      <div className="w-full px-6 lg:px-12 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <img
              src="https://public.readdy.ai/ai/img_res/f7956889-8a63-4f73-b0f9-3e470ed815c3.png"
              alt="Tatsuya Miwa Logo"
              className="w-10 h-10 object-contain"
            />
            <span className={`text-base font-semibold tracking-wider transition-colors ${isScrolled ? 'text-gray-900' : 'text-white'}`} style={{ fontFamily: 'Montserrat, sans-serif' }}>
              TATSUYA MIWA
            </span>
          </div>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center gap-8">
            <button onClick={() => scrollToSection('about')} className={`text-sm font-medium transition-colors hover:text-orange-500 whitespace-nowrap cursor-pointer ${isScrolled ? 'text-gray-700' : 'text-white'}`} style={{ fontFamily: 'Noto Sans JP, sans-serif' }}>自己紹介</button>
            <button onClick={() => scrollToSection('career')} className={`text-sm font-medium transition-colors hover:text-orange-500 whitespace-nowrap cursor-pointer ${isScrolled ? 'text-gray-700' : 'text-white'}`} style={{ fontFamily: 'Noto Sans JP, sans-serif' }}>経歴</button>
            <button onClick={() => scrollToSection('vision')} className={`text-sm font-medium transition-colors hover:text-orange-500 whitespace-nowrap cursor-pointer ${isScrolled ? 'text-gray-700' : 'text-white'}`} style={{ fontFamily: 'Noto Sans JP, sans-serif' }}>ビジョン</button>
            <button onClick={() => scrollToSection('hobbies')} className={`text-sm font-medium transition-colors hover:text-orange-500 whitespace-nowrap cursor-pointer ${isScrolled ? 'text-gray-700' : 'text-white'}`} style={{ fontFamily: 'Noto Sans JP, sans-serif' }}>趣味</button>
            <a
              href="https://www.instagram.com/jasuta_press?igsh=emF6aTlraG12ZW9u&utm_source=qr"
              target="_blank"
              rel="noopener noreferrer"
              className={`w-9 h-9 flex items-center justify-center rounded-full transition-all cursor-pointer ${isScrolled ? 'text-gray-700 hover:text-orange-500' : 'text-white hover:text-orange-400'}`}
            >
              <i className="ri-instagram-line text-xl"></i>
            </a>
          </div>

          {/* Hamburger Button */}
          <button
            className={`md:hidden w-10 h-10 flex items-center justify-center cursor-pointer ${isScrolled ? 'text-gray-900' : 'text-white'}`}
            onClick={() => setMenuOpen(!menuOpen)}
          >
            <i className={`text-2xl ${menuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-white shadow-lg px-6 py-6 flex flex-col gap-5 border-t border-gray-100">
          <button onClick={() => scrollToSection('about')} className="text-sm font-medium text-gray-700 hover:text-orange-500 text-left cursor-pointer" style={{ fontFamily: 'Noto Sans JP, sans-serif' }}>自己紹介</button>
          <button onClick={() => scrollToSection('career')} className="text-sm font-medium text-gray-700 hover:text-orange-500 text-left cursor-pointer" style={{ fontFamily: 'Noto Sans JP, sans-serif' }}>経歴</button>
          <button onClick={() => scrollToSection('vision')} className="text-sm font-medium text-gray-700 hover:text-orange-500 text-left cursor-pointer" style={{ fontFamily: 'Noto Sans JP, sans-serif' }}>ビジョン</button>
          <button onClick={() => scrollToSection('hobbies')} className="text-sm font-medium text-gray-700 hover:text-orange-500 text-left cursor-pointer" style={{ fontFamily: 'Noto Sans JP, sans-serif' }}>趣味</button>
          <a
            href="https://www.instagram.com/jasuta_press?igsh=emF6aTlraG12ZW9u&utm_source=qr"
            target="_blank"
            rel="noopener noreferrer"
            className="w-9 h-9 flex items-center justify-center text-gray-700 hover:text-orange-500 cursor-pointer"
          >
            <i className="ri-instagram-line text-xl"></i>
          </a>
        </div>
      )}
    </nav>
  );
}
